import { Flex, Text } from "@chakra-ui/react";
import { IconCheckeredGarage, IconLeaderboard } from "icons";
import { formatOrdinal } from "utils/helpers";

const DailyRank = ({ position }: { position: number }) => {
  return (
    <Flex
      w="full"
      alignItems="center"
      justifyContent="flex-end"
    >
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="0.5"
      >
        <Text
          fontSize={{ base: '0.625rem', md: '0.75rem' }}
          lineHeight={{ base: '0.625rem', md: '0.75rem' }}
          fontWeight={400}
          color="white.80"
          textTransform="uppercase"
          fontFamily="heading"
          textAlign="center"
        >
          Rank
        </Text>
        
        <Flex gap="1" alignItems="center" justifyContent="flex-end" w="full">
          <Text
            fontSize={{ base: '0.625rem', md: '0.75rem' }}
            lineHeight={{ base: '0.75rem', md: '0.875rem' }}
            fontWeight={600}
            color="white.60"
          >
            {formatOrdinal(position)}
          </Text>
        </Flex>
      </Flex>

      <Flex
        flexDirection={{ base: 'column', md: 'row' }}
        alignItems="center"
        justifyContent="center"
        gap={4}
        zIndex={2}
        background="linear-gradient(225deg, #FFFFFF 0%, #EEEEEE 18%, #A0A0A0 73%, #979797 100%)"
        borderTopRightRadius="12px"
        borderTopLeftRadius="2px"
        borderBottomLeftRadius="12px"
        borderBottomRightRadius="2px"
        width={{ base: '24px', md: '30px' }}
        height={{ base: '20px', md: '26px' }}
        ml="3"
        position="relative"
        _before={{
          content: '""',
          position: "absolute",
          inset: 0,
          borderTopRightRadius: "12px",
          borderTopLeftRadius: "2px",
          borderBottomLeftRadius: "12px",
          borderBottomRightRadius: "2px",
          padding: "2px",
          borderWidth: "0px 1.5px 1.5px 1.5px",
          background: "linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%)",
          mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          maskComposite: "exclude",
        }}
      >
        <IconLeaderboard
          width={{ base: '12px', md: '14px' }}
          height={{ base: '12px', md: '14px' }}
          __css={{
            path: {
              fill: "rgba(0, 0, 0, 0.8)",
            },
          }}
        />
      </Flex>
    </Flex>
  )
}

export default DailyRank;